import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './form-item-mymo-drop-off-survey.component.scss';
var FormItemMymoDropOffSurvey = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemMymoDropOffSurvey, _super);
    function FormItemMymoDropOffSurvey(element) {
        return _super.call(this, element) || this;
    }
    FormItemMymoDropOffSurvey.prototype.init = function () {
        this.form = this.element.querySelector('form');
        this.submitBtn = this.element.querySelector('.js-mymo-drop-off-survey__button');
        this.dropOffReasonOther = this.element.querySelector("input[name=otherReason]");
        this.dropOffOtherReasonSpecify = this.element.querySelector("textarea[name=otherReasonText]");
        this.dropOffOtherReasonSpecify.setAttribute("maxlength", "250");
        this.dropOffOtherReasonSpecifyWrapper = this.element.querySelector(".form-item-mymo-drop-off-survey__otherReasonTextWrapper");
        // display views
        if (this.form) {
            this.displayLoader = this.form.querySelector(".form-container__loader");
            this.displayFields = this.form.querySelector(".form-container__fields");
            this.displaySuccess = this.form.querySelector(".form-container__success");
            this.displayError = this.form.querySelector('.form-container__error');
        }
    };
    FormItemMymoDropOffSurvey.prototype.bindEvents = function () {
        var _this = this;
        this.submitBtn.addEventListener('click', function (event) {
            var _button = event.target;
            var _form = _button.closest('form');
            var formFields = _form.querySelectorAll('input, select, textarea');
            _this.validationService.validate(formFields);
            var isValid = _this.validate(formFields);
            var valid = Array.from(_form.querySelectorAll(".form__group--error"));
            if (isValid && valid.length === 0) {
                _this.submitForm(_form);
            }
        });
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll('input, select, textarea'));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener('blur', function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
        // Reset the form
        this.form.addEventListener("custom_form_reset_event", function (pEvent) {
            _this.showDisplayView("");
            _this.restFormErrors();
        }, false);
        // toggle reasonOther
        this.dropOffReasonOther.addEventListener('click', function (event) {
            _this.toggleOtherReasonCommentBox();
        });
    };
    FormItemMymoDropOffSurvey.prototype.submitForm = function (pForm) {
        var _this = this;
        // collect data
        var dropOffReason = this.getDropOffReason();
        var dropOffComment = this.getDropOffComment();
        var _postData = {
            'surveyDropOffReason': dropOffReason,
            'surveyDropOffComment': dropOffComment,
        };
        /*Code End*/
        this.showDisplayView("loader");
        // url
        var url = this.baseUrl + "/services/MyMoFunnelSurveyForm.jsp";
        // config
        var _config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                'Access-Control-Allow-Origin': '*',
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        this.formsService.postForm(url, this.http.serialiseObject(_postData), _config).then(function (response) {
            if (!response) {
                _this.analyticsService.dtmRecordSiteError("noerrorcode|invalid fields|" + url);
                _this.showDisplayView("error");
            }
            else if (!response.data) {
                _this.analyticsService.dtmRecordSiteError("noerrorcode|invalid fields|" + url);
                _this.showDisplayView("error");
            }
            else if (response.data.includes('invalid')) {
                _this.analyticsService.dtmRecordSiteError("noerrorcode|invalid fields|" + url);
                _this.showDisplayView("error");
            }
            else {
                _this.analyticsService.dtmFormComplete("complete", '200');
                _this.showDisplayView("success");
            }
        }).catch(function (response) {
            // service failed
            _this.analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
            _this.showDisplayView("error");
        });
    };
    FormItemMymoDropOffSurvey.prototype.showDisplayView = function (pDisplay) {
        this.displayLoader.classList.add("hidden");
        this.displayFields.classList.add("hidden");
        this.displaySuccess.classList.add("hidden");
        this.displayError.classList.add("hidden");
        switch (pDisplay) {
            case "success":
                this.displaySuccess.classList.remove("hidden");
                break;
            case "error":
                this.displayError.classList.remove("hidden");
                break;
            case "loader":
                this.displayLoader.classList.remove("hidden");
                break;
            default:
                this.displayFields.classList.remove("hidden");
                break;
        }
    };
    FormItemMymoDropOffSurvey.prototype.hideOtherReasonCommentBox = function () {
        this.dropOffOtherReasonSpecifyWrapper.classList.add("form__group--hidden");
    };
    FormItemMymoDropOffSurvey.prototype.showOtherReasonCommentBox = function () {
        this.dropOffOtherReasonSpecifyWrapper.classList.remove("form__group--hidden");
    };
    FormItemMymoDropOffSurvey.prototype.toggleOtherReasonCommentBox = function () {
        if (this.dropOffReasonOther.checked) {
            this.showOtherReasonCommentBox();
        }
        else {
            this.hideOtherReasonCommentBox();
        }
    };
    FormItemMymoDropOffSurvey.prototype.getDropOffReason = function () {
        var selection = "";
        var fields = Array.from(this.form.querySelectorAll('input'));
        var text = "";
        for (var i = 0; i < fields.length; i++) {
            var field = fields[i];
            if (field.type !== 'hidden') {
                if (field.checked) {
                    text = field.parentNode.parentNode.querySelector("span").textContent;
                    if (selection !== "") {
                        selection += ";" + text;
                    }
                    else {
                        selection = text;
                    }
                }
            }
        }
        return selection;
    };
    FormItemMymoDropOffSurvey.prototype.getDropOffComment = function () {
        if (this.dropOffReasonOther.checked) {
            if (this.dropOffOtherReasonSpecify.value) {
                return this.dropOffOtherReasonSpecify.value;
            }
        }
        return "";
    };
    FormItemMymoDropOffSurvey.prototype.validate = function (fields) {
        var selection = this.getDropOffReason();
        var comment = this.getDropOffComment();
        var isValid = false;
        if (selection) {
            if (this.dropOffReasonOther.checked) {
                this.hideAtleastOneSelectionErrorMessage();
                if (this.dropOffOtherReasonSpecify.value) {
                    isValid = true;
                }
                else {
                    isValid = false;
                }
            }
            else {
                this.hideAtleastOneSelectionErrorMessage();
                isValid = true;
            }
        }
        else {
            this.showAtleastOneSelectionErrorMessage();
            isValid = false;
        }
        return isValid;
    };
    FormItemMymoDropOffSurvey.prototype.showAtleastOneSelectionErrorMessage = function () {
        this.element.querySelector(".form-item-mymo-drop-off-survey__atleastOneSelectionErrorMessage").classList.remove('hidden');
    };
    FormItemMymoDropOffSurvey.prototype.hideAtleastOneSelectionErrorMessage = function () {
        this.element.querySelector(".form-item-mymo-drop-off-survey__atleastOneSelectionErrorMessage").classList.add('hidden');
    };
    FormItemMymoDropOffSurvey.prototype.restFormErrors = function () {
        this.hideOtherReasonCommentBox();
        this.hideAtleastOneSelectionErrorMessage();
    };
    return FormItemMymoDropOffSurvey;
}(Base));
export { FormItemMymoDropOffSurvey };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-mymo-drop-off-survey/form-item-mymo-drop-off-survey.component.ts
// module id = 955
// module chunks = 0